import {
  IonButton, IonButtons, IonImg, IonLabel,
} from '@ionic/react';

import styles from './Auxiliary.module.scss';

interface AuxiliaryProps {
  screen: string;
  title: string;
  subtitle?: string;
  imgSrc: any;
  mainButton?: string;
  secondaryButton?: string;
  helpText?: string;
  handleMainButton: () => void;
  handleSecondaryButton?: () => void;
}

export default function Auxiliary({
  screen,
  title,
  subtitle,
  imgSrc,
  mainButton,
  secondaryButton,
  helpText,
  handleMainButton,
  handleSecondaryButton,
}: AuxiliaryProps) {
  return (
    <div id={`${screen}-modal`} className={styles.auxiliaryModalContainer}>
      <div className={styles.modalTitleWrapper}>
        <IonLabel className={styles.modalTitle}>{title}</IonLabel>
        <IonLabel className={styles.modalSubtitle}>{subtitle}</IonLabel>
        {helpText && (
          <IonLabel
            className={styles.modalSubtitle}
          >
            <span dangerouslySetInnerHTML={{ __html: helpText }} />
          </IonLabel>
        )}
      </div>

      <IonImg src={imgSrc} />
      <IonButtons className={styles.modalBtnGroup}>
        {mainButton
          && (
            <IonButton
              className={'nextButton'}
              onClick={() => handleMainButton()}
            >
              {mainButton}
            </IonButton>
          )}
        {secondaryButton
          && (
            <IonButton
              className={'secondaryButton'}
              onClick={() => handleSecondaryButton && handleSecondaryButton()}
            >
              {secondaryButton}
            </IonButton>
          )}
      </IonButtons>
    </div>
  );
}
